import React, { Component } from "react";
import { CarouselWrapper, next, prev } from "react-pretty-carousel";

class Panelo extends Component {
  render() {
    return (
      <section className="bg-gray-100  pb-16 lg:pb-28 relative">
        <h2 className="text-heading-color text-4xl pt-11 font-bold text-center mb-16">
          PANELO IN REAL <br /> WORLD
        </h2>

        <div className="lg:mx-32 flex flex-col lg:flex-row justify-center items-center">
          <CarouselWrapper items={3} mode="gallery" showControls={false}>
            <img loading="lazy" src="./img/img-2.png" alt="" />
            <img loading="lazy" src="./img/img-2.png" alt="" />
            <img loading="lazy" src="./img/img-2.png" alt="" />
            <img loading="lazy" src="./img/img-2.png" alt="" />
            <img loading="lazy" src="./img/img-2.png" alt="" />
            <img loading="lazy" src="./img/img-2.png" alt="" />
          </CarouselWrapper>
          <div className="arrow flex justify-center lg:justify-between lg:absolute w-full">
            <button
              className="ml-10"
              onClick={() => {
                next();
              }}
            >
              <img src="./img/arrow-left.png" alt="" />
            </button>
            <button
              className="mr-10"
              onClick={() => {
                prev();
              }}
            >
              <img src="./img/arrow-right.png" alt="" />
            </button>
          </div>
        </div>
      </section>
    );
  }
}

export default Panelo;
